import { CategoryDtoCategoriesEnum } from '@b-stock/listing-api-client'

import { ApiCategory } from './apiCategories'

// Note: The merchandise categories in account portal (registration) have changed over time.
// We support: (1) legacy human-readable strings (title/sentence case), (2) enum values (UPPER_SNAKE_CASE from account portal).
// Lookup tries raw value first (for enums) then lowercased (for human-readable).
const categoryMapping: Record<string, ApiCategory> = {
  // Legacy human-readable (lowercase for case-insensitive lookup)
  'apparel, shoes & accessories': ApiCategory.ApparelShoesAndAccessories,
  'apparel, footwear & accessories': ApiCategory.ApparelShoesAndAccessories,
  'apparel, shoes, & accessories': ApiCategory.ApparelShoesAndAccessories,
  appliances: ApiCategory.MajorAppliances,
  'automotive supplies': ApiCategory.AutomotiveSupplies,
  'books, movies & music': ApiCategory.BooksMoviesAndMusic,
  'books, music & movies': ApiCategory.BooksMoviesAndMusic,
  'cell phones': ApiCategory.CellPhones,
  electronics: ApiCategory.Electronics,
  'computers, equipment & software': ApiCategory.Electronics,
  'consumer electronics': ApiCategory.Electronics,
  'computer, equipment & software': ApiCategory.Electronics,
  tvs: ApiCategory.Electronics,
  'health & beauty': ApiCategory.HealthAndBeauty,
  groceries: ApiCategory.Groceries,
  furniture: ApiCategory.Furniture,
  'home & garden': ApiCategory.HomeAndGarden,
  'building & industrial': ApiCategory.BuildingAndIndustrial,
  'industrial equipment': ApiCategory.BuildingAndIndustrial,
  'jewelry & watches': ApiCategory.JewelryAndWatches,
  'mixed lots': ApiCategory.MixedLots,
  'office supplies & equipment': ApiCategory.OfficeSuppliesAndEquipment,
  'sports & outdoors': ApiCategory.SportsAndOutdoors,
  'sports & outdoor': ApiCategory.SportsAndOutdoors,
  'toys, kids & baby': ApiCategory.ToysKidsAndBaby,
  pets: ApiCategory.Pets,
  // Enum values (UPPER_SNAKE_CASE from account portal)
  [CategoryDtoCategoriesEnum.ApparelFootwearAndAccessories]:
    ApiCategory.ApparelShoesAndAccessories,
  [CategoryDtoCategoriesEnum.AutomotiveSupplies]:
    ApiCategory.AutomotiveSupplies,
  [CategoryDtoCategoriesEnum.BooksMoviesAndMusic]:
    ApiCategory.BooksMoviesAndMusic,
  [CategoryDtoCategoriesEnum.CellPhones]: ApiCategory.CellPhones,
  [CategoryDtoCategoriesEnum.ConsumerElectronics]: ApiCategory.Electronics,
  [CategoryDtoCategoriesEnum.Furniture]: ApiCategory.Furniture,
  [CategoryDtoCategoriesEnum.Groceries]: ApiCategory.Groceries,
  [CategoryDtoCategoriesEnum.HealthAndBeauty]: ApiCategory.HealthAndBeauty,
  [CategoryDtoCategoriesEnum.HomeAndGarden]: ApiCategory.HomeAndGarden,
  [CategoryDtoCategoriesEnum.IndustrialEquipmentAndBuilding]:
    ApiCategory.BuildingAndIndustrial,
  [CategoryDtoCategoriesEnum.JewelryAndWatches]: ApiCategory.JewelryAndWatches,
  [CategoryDtoCategoriesEnum.MajorAppliances]: ApiCategory.MajorAppliances,
  [CategoryDtoCategoriesEnum.MixedLots]: ApiCategory.MixedLots,
  [CategoryDtoCategoriesEnum.OfficeSuppliesAndEquipment]:
    ApiCategory.OfficeSuppliesAndEquipment,
  [CategoryDtoCategoriesEnum.Pets]: ApiCategory.Pets,
  [CategoryDtoCategoriesEnum.SmallAppliances]: ApiCategory.SmallAppliances,
  [CategoryDtoCategoriesEnum.SportsAndOutdoors]: ApiCategory.SportsAndOutdoors,
  [CategoryDtoCategoriesEnum.ToysKidsAndBaby]: ApiCategory.ToysKidsAndBaby,
}

export function mapBuyingMerchandiseToCategories(
  categories: string[]
): ApiCategory[] {
  return categories.reduce<ApiCategory[]>((acc, category) => {
    const mappedCategory =
      categoryMapping[category] ?? categoryMapping[category.toLowerCase()]
    if (mappedCategory) {
      acc.push(mappedCategory)
    }
    return acc
  }, [])
}
